import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Kejian"
});
const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20.0011 8.125C12.0466 8.125 5.20597 13.0338 2.5 20C5.20597 26.9662 12.0466 31.875 20.0011 31.875C27.9559 31.875 34.7988 26.9662 37.5023 20C34.7987 13.0337 27.9559 8.125 20.0011 8.125M20.0011 27.9159C15.5472 27.9159 12.0465 24.4345 12.0465 20C12.0465 15.5655 15.5472 12.084 20.0011 12.084C24.4574 12.084 27.9558 15.5655 27.9558 20C27.9558 24.4345 24.4574 27.9159 20.0011 27.9159M20.0011 15.2501C17.2976 15.2501 15.228 17.3096 15.228 20C15.228 22.6906 17.2976 24.75 20.0011 24.75C22.7071 24.75 24.7744 22.6905 24.7744 20C24.7744 17.3096 22.7071 15.2501 20.0011 15.2501",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var kejian = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { kejian as default };
